import { PropsWithChildren, SubmitEventHandler } from 'react';
import { FormProvider } from '@/Contexts';
import { InertiaFormProps } from '@inertiajs/react';

type FormProps<TForm extends object> = PropsWithChildren<{
    form: Omit<InertiaFormProps<TForm>, 'processing' | 'progress' | 'get' | 'post' | 'put' | 'patch' | 'delete' | 'transform' | 'cancel' | 'recentlySuccessful' | 'wasSuccessful'>;
    onSubmit?: SubmitEventHandler;
    className?: string;
}>

export const Form = <TForm extends object>({ form, onSubmit, children, ...rest }: FormProps<TForm>) => {
    return (
        // @ts-ignore
        <FormProvider value={form}>
            <form onSubmit={onSubmit} {...rest}>
                {children}
            </form>
        </FormProvider>
    );
};
